export default __webpack_public_path__ + "static/media/openstage-header.0be8001b.svg";